import { defineComponent, computed, createBlock, createElementBlock, openBlock, renderSlot, Fragment, createTextVNode, toDisplayString } from "vue";
import PSkeletonLoader from "../p-skeleton-loader.js";
const _hoisted_1 = {
  key: 1,
  class: "text-sm font-medium text-p-gray-40"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "PPaginationInfo" },
  __name: "p-pagination-info",
  props: {
    /**
     * The current page.
     */
    currentPage: {
      type: Number,
      default: 0
    },
    /**
     * The amount of data pagination iterates through.
     */
    count: {
      type: Number,
      default: 0
    },
    /**
     * The amount of data to be displayed at 1 page. Used to calculate the `from` and `to` limits.
     */
    pageSize: {
      type: Number,
      default: 0
    },
    /**
     * Whether the pagination is loading.
     */
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const from = computed(() => {
      const maxNumOfPages = Math.ceil(props.count / props.pageSize);
      const currentPage = props.currentPage > maxNumOfPages ? maxNumOfPages : props.currentPage;
      return (currentPage - 1) * props.pageSize + 1;
    });
    const to = computed(() => {
      const to2 = props.currentPage * props.pageSize;
      return to2 >= props.count ? props.count : to2;
    });
    return (_ctx, _cache) => {
      return __props.loading ? (openBlock(), createBlock(PSkeletonLoader, {
        key: 0,
        class: "h-6 w-56"
      })) : (openBlock(), createElementBlock("div", _hoisted_1, [
        __props.count ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode("Showing " + toDisplayString(from.value) + " to " + toDisplayString(to.value) + " of " + toDisplayString(__props.count) + " results", 1)
        ], 64)) : renderSlot(_ctx.$slots, "no-results", { key: 1 }, () => [
          _cache[0] || (_cache[0] = createTextVNode("No results found"))
        ])
      ]));
    };
  }
});
export {
  _sfc_main as _
};
